// #region Imports
import { motion, useTransform } from "framer-motion";
// #endregion

function Rotator({ scrollY }) {
    const rotation = useTransform(scrollY, [0, 0.8], ["-20deg", "0deg"]);

    const textRotation = useTransform(scrollY, [0, 0.6], ["20deg", "80deg"]);

    const size = useTransform(scrollY, [0, 0.5], [1, 0.2]);

    const opacity = useTransform(scrollY, [0.9, 1], [0, 1]);

    const yTransition = useTransform(scrollY, [0, 1], ["3vh", "5vh"]);

    const textOpacity = useTransform(scrollY, [0.4, 0.6], [1, 0]);

    const borderOpacity = useTransform(scrollY, [0.8, 1], [1, 0]);

    return (
        <motion.div
            className="
                sticky z-[100] -top-[3vh] flex 
                justify-center items-center mr-4 
                small:hidden
            "
            style={{
                rotate: rotation,
                scale: size,
                y: yTransition,
            }}
        >
            <motion.div
                className="
                    w-[95vh] h-[95vh] border-[0.2rem] border-blue flex 
                    justify-center items-center relative self-center
                "
                style={{
                    opacity: borderOpacity,
                }}
            >
                <div className="w-[4%] h-[4%] z-30 border-2 border-blue bg-ivory absolute -top-4 -left-4"></div>
                <div className="w-[4%] h-[4%] z-30 border-2 border-blue bg-ivory absolute -top-4 -right-4"></div>
                <div className="w-[4%] h-[4%] z-30 border-2 border-blue bg-ivory absolute -bottom-4 -left-4"></div>
                <div className="w-[4%] h-[4%] z-30 border-2 border-blue bg-ivory absolute -bottom-4 -right-4"></div>

                <div className="border-[0.2rem] border-blue rounded-full w-[98%] h-[98%]"></div>

                <motion.p
                    className="w-[50%] text-[3vw] small:text-[3vh] left-[15vh] bottom-[40vh] tracking-tightest text-left z-20 absolute leading-none italic font-luimp font-[300]"
                    style={{
                        rotate: textRotation,
                        opacity: textOpacity,
                    }}
                >
                    EVERYTHING I’VE BUILT ALONG THE WAY
                </motion.p>
            </motion.div>


            <motion.a 
                href="/" 
                className="
                    h-full w-[90%] absolute rounded-[4rem] 
                    overflow-hidden hover:border-8 duration-500 
                    border-blue p-8 transition-all ease-in-out
                "
                style={{
                    opacity: opacity,
                }}
            >
                <img
                    className="h-full w-full"
                    fetchPriority="high"
                    src="logo.svg"
                    alt="Home"
                />
            </motion.a>
        </motion.div>
    );
}

export default Rotator;
